(function(root){
 const normalize=value=>String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9\u4e00-\u9fff]/g,'');
 function searchGrinders(grinders,query){
  const words=String(query||'').trim().split(/\s+/).map(normalize).filter(Boolean);
  return grinders.filter(g=>{const hay=normalize([g.brand,g.model,...(g.aliases||[])].join(' '));return words.every(w=>hay.includes(w));});
 }
 function matchModel(data,input){
  const grinder=data.grinders.find(g=>g.id===input.grinderId);
  if(!grinder)return {status:'unlisted',products:[],purchaseReady:false};
  if(grinder.status==='pending')return {status:'pending',grinder,products:[],purchaseReady:false};
  const products=data.products.filter(p=>grinder.productIds.includes(p.id));
  const mount=input.mount||'unknown';
  if(mount!=='unknown'&&!products.some(p=>p.mount===mount))return {status:'conflict',grinder,products:[],purchaseReady:false};
  const filtered=mount==='unknown'?products:products.filter(p=>p.mount===mount);
  return {status:input.revision==='standard'&&mount!=='unknown'?'listed':'review',grinder,products:filtered,purchaseReady:false};
 }
 function dimensionCandidates(data,input){
  const diameter=Number(input.diameter),inner=input.inner===''||input.inner==null?null:Number(input.inner),thickness=input.thickness===''||input.thickness==null?null:Number(input.thickness);
  if(!Number.isFinite(diameter)||diameter<=0||(inner!==null&&(!Number.isFinite(inner)||inner<=0||inner>=diameter))||(thickness!==null&&(!Number.isFinite(thickness)||thickness<=0)))return {status:'invalid',products:[],purchaseReady:false};
  if(input.type==='conical')return {status:'unlisted',products:[],purchaseReady:false};
  return {status:'candidates',products:data.products.filter(p=>p.status!=='pending'&&p.diameter===diameter&&(!input.mount||input.mount==='unknown'||p.mount===input.mount)),purchaseReady:false};
 }
 function directoryRecords(data,input={}){
  const words=String(input.query||'').trim().split(/\s+/).map(normalize).filter(Boolean);
  return data.grinders.filter(g=>{
   const sizes=[g.nominalDiameter,...data.products.filter(p=>g.productIds.includes(p.id)).map(p=>p.diameter)].filter(Boolean);
   const hay=normalize([g.brand,g.model,...(g.aliases||[]),...sizes.map(n=>`${n}mm ${n}`)].join(' '));
   return words.every(w=>hay.includes(w))&&(!input.size||sizes.includes(Number(input.size)));
  }).sort((a,b)=>(a.brand+' '+a.model).localeCompare(b.brand+' '+b.model));
 }
 const api={searchGrinders,matchModel,dimensionCandidates,directoryRecords};
 if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.LBMatch=api;
})(typeof globalThis!=='undefined'?globalThis:this);
